import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import AreaAtuacaoervice from '../../app/service/AreaAtuacaoService'

class AreaAtuacao extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      codigo: '',
      area: null,
      areas: [],
      nome: '',
      detail: '',
      modalArea: null,
      modalAreaAlterar: null,
      openSpinner: false
    }

    this.areaAtuacaoService = new AreaAtuacaoervice();

    this.renderFooterCadastroArea = this.renderFooterCadastroArea.bind(this);
    this.renderFooterAlterarArea = this.renderFooterAlterarArea.bind(this);
    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
  }

  renderFooterCadastroArea(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarArea}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarArea(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarArea}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  alterarArea = async () => {
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Área de Atuação', detail:'Informe a Área de Atuação', life: 4000});
      return;
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    const area = {
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }
    this.setState({openSpinner: true});
    await this.areaAtuacaoService.alterarAreaAtuacao(area)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Área de Atuação', detail:'Área de Atuação alterada com sucesso !', life: 4000});
        this.listarAreaAtuacao();
        this.fecharModal('modalAreaAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Área de Atuação', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarArea = async () => {
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Área de Atuação', detail:'Informe a Área de Atuação', life: 4000});
      return;
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    const area = {
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }
    this.setState({openSpinner: true});
    await this.areaAtuacaoService.cadastrarAreaAtuacao(area)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Área de Atuação', detail:'Área de Atuação cdastrada com sucesso !', life: 4000});
        this.listarAreaAtuacao();
        this.fecharModal('modalArea');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Área de Atuação', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  listarAreaAtuacao = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.areaAtuacaoService.listarAreaAtuacao(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({areas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Área de Atuação', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos = () => {
    this.setState({nome: ''});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarArea(rowData)}
                tooltip="Editar Área de Atuação" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Área de Atuação" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  async consultarArea(area) {
    this.setState({openSpinner: true});
    await this.areaAtuacaoService.consultarAreaAtuacao(area.codigo)
      .then(response => {
        this.setState({area: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        this.abrirModaAlterar('modalAreaAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Área de Atuação', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  confirmaExclusao(area) {
    this.setState({codigo: area.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Área de Atuação?',
        header: 'Exclusão de Área de Atuação',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  async excluirArea() {
    this.setState({openSpinner: true});
    await this.areaAtuacaoService.excluirAreaAtuacao(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Área de Atuação', detail:'Área de Atuação excluída com sucesso', life: 4000});
        this.listarAreaAtuacao();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Área de Atuação', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirArea();
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarAreaAtuacao();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Área de Atuação */}
          <Dialog header="Cadastro de Áreas de Atuação"
                    visible={this.state.modalArea} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroArea('modalArea')} 
                    onHide={() => this.fecharModal('modalArea')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeArea">Nome</label>
                        <InputText id="nomeArea" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Área de Atuação */}
          <Dialog header="Alterar Área de Atuação"
                    visible={this.state.modalAreaAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarArea('modalAreaAlterar')} 
                    onHide={() => this.fecharModal('modalAreaAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeAreaAlterar">Nome</label>
                        <InputText id="nomeAreaAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-book"></i>
                        <span> Áreas de Atuação</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalArea')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.areas}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      emptyMessage=" "
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}
AreaAtuacao.contextType = AuthContext;
export default withRouter (AreaAtuacao)